import closeIcon from "../../../../assets/documents/closeVector.svg";
import infoIcon from "../../../../assets/icons/question.svg";
import { useAnalytics } from "../../../../analytics/useAnalytics";
import { EVENT_NAMES } from "../../../../analytics/events";

import "./UpcomingLeavesWidget.scss";

import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}.${d.getFullYear()}`;
};

const pluralDays = (n) => {
    const mod10 = n % 10;
    const mod100 = n % 100;
    if (mod10 === 1 && mod100 !== 11) return "день";
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return "дня";
    return "дней";
};

const UpcomingLeavesWidget = ({ description, leaves }) => {
    const navigate = useNavigate();
    const { trackEvent } = useAnalytics();
    const [isVisible, setIsVisible] = useState(false);
    const hideTimeout = useRef(null);

    const handleMouseEnter = () => {
        clearTimeout(hideTimeout.current);
        setIsVisible(true);
    };

    const handleMouseLeave = () => {
        hideTimeout.current = setTimeout(() => setIsVisible(false), 150);
    };

    useEffect(() => {
        return () => clearTimeout(hideTimeout.current);
    }, []);

    useEffect(() => {
        if (isVisible) trackEvent(EVENT_NAMES.UPCOMING_LEAVES_WIDGET_OPENED);
    }, [isVisible, trackEvent]);

    const handleClose = () => setIsVisible(false);

    const widgetClass = [
        "information-part__widgets__item",
        "upcoming-leaves-widget",
        leaves.length > 0 ? "upcoming-leaves-widget--has-leaves" : "",
    ].filter(Boolean).join(" ");

    return (
        <div
            className={widgetClass}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div className="information-part__widgets__block-head">Предстоящий отпуск</div>
            <div className="information-part__widgets__description">{description}</div>

            <div className={`upcoming-leaves-panel${isVisible ? " upcoming-leaves-panel--visible" : ""}`}>
                <div className="upcoming-leaves-panel__header">
                    <span className="upcoming-leaves-panel__title">Предстоящие отпуска</span>
                    <button className="upcoming-leaves-panel__close" onClick={handleClose}>
                        <img src={closeIcon} alt="закрыть" width={12} height={12} />
                    </button>
                </div>

                <div className="upcoming-leaves-panel__list">
                    {leaves.length === 0 ? (
                        <p className="upcoming-leaves-panel__empty">Нет предстоящих отпусков</p>
                    ) : (
                        leaves.map((leave, i) => (
                            <div key={i} className="upcoming-leaves-panel__item">
                                <div className="upcoming-leaves-panel__item-row">
                                    <div className="upcoming-leaves-panel__cal-widget">
                                        <div className="upcoming-leaves-panel__cal-widget__stripe" />
                                        <div className="upcoming-leaves-panel__cal-widget__day">
                                            {new Date(leave.from).getDate()}
                                        </div>
                                    </div>
                                    <div className="upcoming-leaves-panel__item-content">
                                        <div className="upcoming-leaves-panel__item-top">
                                            <span className="upcoming-leaves-panel__dates">
                                                {formatDate(leave.from)} – {formatDate(leave.to)}{"  "}
                                              <span>
                                                    ({leave.days}&nbsp;{pluralDays(leave.days)})
                                              </span>
                                            </span>
                                            {leave.isNearest && (
                                                <span className="upcoming-leaves-panel__badge">Ближайший</span>
                                            )}
                                        </div>
                                        <div className="upcoming-leaves-panel__type">{leave.typeName}</div>
                                        {(leave.approvedDate || leave.approveDate) && (
                                            <div className="upcoming-leaves-panel__approved">
                                                Утвержден&nbsp;
                                                {formatDate(leave.approvedDate || leave.approveDate)}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {i < leaves.length - 1 && <div className="upcoming-leaves-panel__divider" />}
                            </div>
                        ))
                    )}
                </div>

                <div className="upcoming-leaves-panel__footer">
                    <div className="upcoming-leaves-panel__footer-top">
                        <img
                            src={infoIcon}
                            alt=""
                            width={20}
                            height={20}
                            className="upcoming-leaves-panel__info-icon"
                        />
                        <div className="upcoming-leaves-panel__footer-text">
                            <div className="upcoming-leaves-panel__info-title">Этот график актуален?</div>
                            <div className="upcoming-leaves-panel__info-text">
                                Подайте заявку заранее, если ваши планы изменились.
                            </div>
                        </div>
                    </div>
                    <button
                        className="upcoming-leaves-panel__apply-btn"
                        onClick={() => navigate("/main/hr-services/work-time/requests")}
                    >
                        ПОДАТЬ ЗАЯВЛЕНИЕ →
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UpcomingLeavesWidget;
